module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/463.b1f66eaf.png";